// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"72":"thanks","189":"brief","314":"style","444":"designs","691":"colors"}[chunkId] || chunkId) + "." + {"72":"22bce281","189":"00c0c7b1","314":"264420e2","402":"5d0e6e22","444":"1b2c6fc8","520":"1eab83b2","605":"8642e08e","691":"76df9de6","742":"15312fb2"}[chunkId] + ".js";
};